/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Type rate unit of the charging profile
 */
export enum ChargePointChargingProfileScheduleRateUnitType {
  W = 'W',
  A = 'A'
}
